import React, { useState, useEffect, useRef, useCallback } from 'react';
import BotonBuscarChico from '../UI/botones/BotonBuscarChico.js';
import CampoComboPais from '../UI/campos/CampoComboPais.js';
import CampoEditableTexto from '../UI/campos/CampoEditableTexto.js';
import PopupCancelable from '../UI/PopupCancelable.js';
import { Sexo } from '../UI/campos/CampoOptionsSexo.js';
import { encontrarIdNumber } from '../funciones/FuncionesArray.js';
import * as Data from '../data/DataPersonas.js';
import * as FuncionesFecha from '../funciones/FuncionesFecha.js';
import { NombreCompleto } from '../funciones/FuncionesPersona.js';
import styles from './PopupBuscarPersona.module.css';

const CamposFiltro = {
  APELLIDO: 'apellido',
  NOMBRE: 'nombre',
  PAIS: 'pais',
};

const FiltroVacio = {
  apellido: '',
  nombre: '',
  sexo: Sexo.MASCULINO,
  pais: null,
};

const filtroInicial = (persona) => {
  return persona
    ? {
        apellido: persona.apellido,
        nombre: persona.nombre,
        pais: persona.paisNacimiento,
      }
    : FiltroVacio;
};

const PopupBuscarPersona = (props) => {
  const visible = props.visible;
  const persona = props.valor;
  const [personaFocus, setPersonaFocus] = useState(null);
  const [filtros, setFiltros] = useState(filtroInicial(props.valor));
  const [personas, setPersonas] = useState([]);
  const buttonReferences = useRef([]);

  const onClickBuscar = () => {
    buscarPersonas(filtros);
  };

  const buscarPersonas = useCallback(async (filtrosBuscar) => {
    if (filtrosBuscar.apellido && filtrosBuscar.apellido.toString().length > 3) {
      const result = await Data.SearchPersonasNueva(filtrosBuscar);
      if (result && result !== Promise.resolve(result)) {
        setPersonas(result);
      }
    }
  }, []);

  // efecto para cargar la lista si vienen valores precargados
  useEffect(() => {
    if (visible) {
      const filtroNuevo = filtroInicial(persona);
      setFiltros(filtroNuevo);
      buscarPersonas(filtroNuevo);
    }
  }, [visible, persona, setFiltros, buscarPersonas]);

  const vaciarForm = () => {
    setPersonas(null);
    setPersonaFocus(null);
  };

  const onCampoChange = (nombre, valor) => {
    switch (nombre) {
      case CamposFiltro.APELLIDO: {
        setFiltros({ ...filtros, apellido: valor });
        break;
      }
      case CamposFiltro.NOMBRE: {
        setFiltros({ ...filtros, nombre: valor });
        break;
      }
      default:
    }
    setPersonaFocus(null);
  };

  const onPaisElegido = (nombre, paisElegido) => {
    let filtrosNuevo;
    filtrosNuevo =
      paisElegido && !paisElegido.id
        ? { ...filtros, paisNacimiento: null }
        : { ...filtros, paisNacimiento: paisElegido };
    setFiltros(filtrosNuevo);
    buscarPersonas(filtrosNuevo);
  };

  const personaClickHandler = (event) => {
    event.preventDefault();
    const persona = encontrarIdNumber(personas, event.target.id);
    if (persona) {
      props.onPersonaElegida(persona);
      vaciarForm();
    }
  };

  const personaFocusHandler = (persona) => {
    setPersonaFocus(persona);
  };

  const onAceptar = () => {
    if (personaFocus) {
      props.onPersonaElegido(personaFocus);
      vaciarForm();
    } else {
      alert('Seleccione un persona');
    }
  };

  const onCancelar = () => {
    props.onCancelar();
    vaciarForm();
  };

  const textoPersona = (persona) => {
    let texto = '';
    if (persona) {
      texto = NombreCompleto(persona);
      if (persona.pais) {
        texto += ' (' + persona.pais.nombre + ')';
      }
      if (persona.anioNacimiento) {
        texto +=
          ' - ' +
          FuncionesFecha.CamposToFechaCorta(
            persona.anioNacimiento,
            persona.mesNacimiento,
            persona.diaNacimiento
          );
      }
    }
    return texto;
  };

  let lista = [];
  if (personas) {
    for (const persona_ of personas) {
      lista = [...lista, persona_];
      if (lista.length === 10) {
        break;
      }
    }
  }

  return (
    <PopupCancelable
      visible={visible}
      texto=""
      height="20rem"
      width="28rem"
      mostrarEliminar={false}
      isGrabando={false}
      onAceptar={onAceptar}
      onCancelar={onCancelar}
    >
      <div className={`${styles.cuadroBusqueda}`}>
        <div className={`${styles.filaBusqueda}`}>
          <span className={`${styles.textoBusqueda}`}>Apellido:</span>
          <CampoEditableTexto
            nombre={CamposFiltro.APELLIDO}
            valor={filtros.apellido}
            largo={50}
            editar={true}
            estilo={`${styles.campoApellido}`}
            onChange={onCampoChange}
            onPressEnter={onClickBuscar}
          />
        </div>
        <div className={`${styles.filaBusqueda}`}>
          <span className={`${styles.textoBusqueda}`}>Nombre:</span>
          <CampoEditableTexto
            nombre={CamposFiltro.NOMBRE}
            valor={filtros.nombre}
            largo={50}
            editar={true}
            estilo={`${styles.campoNombre}`}
            onChange={onCampoChange}
            onPressEnter={onClickBuscar}
          />
        </div>
        <div className={`${styles.filaBusqueda}`}>
          <span className={`${styles.textoBusqueda}`}>País:</span>
          <CampoComboPais
            nombre={CamposFiltro.PAIS}
            valor={filtros.pais}
            editar={true}
            incluirNulo={true}
            estilo={`${styles.campoPais}`}
            onChange={onPaisElegido}
          />
          <BotonBuscarChico estilo={`${styles.boton}`} onClick={onClickBuscar}></BotonBuscarChico>
        </div>
      </div>
      <div className={`${styles.listaPersonas}`}>
        {lista.length === 0 && (
          <span className={`${styles.listaVacia}`}>
            Ingrese al menos tres letras del apellido a buscar
          </span>
        )}
        <ul>
          {lista.map((persona, index) => (
            <li key={persona.id} id={persona.id}>
              <button
                className={`${styles.itemPersona}`}
                key={persona.id}
                ref={(element) => (buttonReferences.current[index] = element)}
                id={persona.id}
                onClick={personaClickHandler}
                onFocus={() => personaFocusHandler(persona)}
              >
                {textoPersona(persona)}
              </button>
            </li>
          ))}
        </ul>
      </div>
    </PopupCancelable>
  );
};

export default PopupBuscarPersona;
